import { useMobile } from '@pulseops/common'
import { TFunctionResult } from 'i18next'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { StyleProp, StyleSheet, Text, View, ViewStyle } from 'react-native'

export type DataSource = {
  label: string | number | boolean | JSX.Element | TFunctionResult
  value: string | number | boolean | JSX.Element | TFunctionResult
  suffix?: string | number | boolean | JSX.Element
  isHighlight?: boolean
  isBold?: boolean
}

const InfoViewItem: React.FC<DataSource> = (props) => {
  const { label, value, suffix, isHighlight, isBold } = props
  const { isMobile } = useMobile()

  return (
    <View style={isMobile ? styles.colFull : styles.col}>
      <Text style={styles.label}>{label}</Text>
      <Text style={[styles.value, isHighlight && styles.highLight, isBold && styles.bold]}>
        {value} {suffix}
      </Text>
    </View>
  )
}

export const InfoViewList = ({
  dataSource,
  containerStyle
}: {
  dataSource: DataSource[]
  containerStyle?: StyleProp<ViewStyle>
}) => {
  const { t } = useTranslation()
  let xhtml: JSX.Element[] = [
    <Text key={1} style={styles.noData}>
      {t('common:Nodata')}
    </Text>
  ]
  if (dataSource.length > 0) {
    xhtml = dataSource.map((data, i) => (
      <InfoViewItem
        key={i}
        label={data.label}
        value={data.value}
        suffix={data.suffix}
        isHighlight={data.isHighlight}
        isBold={data.isBold}
      />
    ))
  }

  return <View style={[styles.row, containerStyle]}>{xhtml}</View>
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  col: {
    width: '33.33333333333%',
    marginBottom: 32
  },
  colFull: {
    width: '100%',
    marginBottom: 16
  },
  label: {
    color: '#70777E',
    fontSize: 15,
    fontWeight: 'bold',
    lineHeight: 20,
    marginBottom: 8
  },
  value: {
    color: '#000000',
    fontSize: 15,
    lineHeight: 22
  },
  noData: { textAlign: 'center', width: '100%' },
  highLight: { color: '#eD1B2E' },
  bold: { fontWeight: 'bold' }
})
